import { render, staticRenderFns } from "./EndorsementContractBroker.vue?vue&type=template&id=0f30bf6d"
import script from "./EndorsementContractBroker.vue?vue&type=script&lang=js"
export * from "./EndorsementContractBroker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports